<template>
  <div class="inner-main">
    <div class="fundding-news">
      <div class="news-title">
        {{$t("fundingNews")}}
      </div>
      <div class="item"
        v-for="item in data.newsFundingList"
        :key="item.id">
        <div class="top">
          <div class="name">
            {{item.newsTitle}}
          </div>
          <div class="date">
            {{getDate(item.publishDate)}}
          </div>
        </div>
        <!-- <div class="news-info">
                    {{ getSubContent(item.newsContent)}}
                </div> -->
      </div>

      <div class="more"
        @click="more(1)">
        查看更多 >
      </div>
    </div>
    <div class="cutter"></div>
    <div class="fundding">
      <div class="title">
        <div>{{$t("fundingEvent")}}</div>

      </div>
      <div class="item"
        v-for="item2 in data.fundingList"
        :key="item2.id">
        <div class="info">
          <div class="top">
            <div class="dot"></div>
            <div class="name"
              @click="gotoCompanyDetail(item2.company.id)">
              {{item2.company.name}}
            </div>
          </div>
          <div class="content">
            <div class="desc">
              <span>公司简介：</span>
              <span> {{item2.company.introduction}}</span>
            </div>
            <div class="field">
              <span>行业领域：</span>
              <span>
                <span v-for="fd in industryFieldArr(item2.company.industryField)"
                  :key="fd">
                  {{fd}}
                </span>
              </span>
            </div>
            <div class="area">
              <span>地区：</span>

              <span v-if="item2.company.isAdd">{{item2.company.region}}</span>
              <span v-else>{{item2.company.city}}{{item2.company.district}}</span>
            </div>
            <div class="invest">
              <div class="left">
                <div class="key">投资时间</div>
                <div class="value">{{getDate(item2.fundingDate)}}</div>
              </div>
              <div class="center">
                <div class="key">投资轮次</div>
                <div class="value">{{item2.round}}</div>
              </div>
              <div class="right">
                <div class="key">获投金额</div>
                <div class="value"
                  v-if="item2.investment"> {{formatChineseAmount(item2.investment, item2.currency)}}</div>
                <div class="value"
                  v-else>{{formatDollar(item2.investmentDollar)}}</div>
              </div>
            </div>
            <div class="invest2">
              <div class="center">
                <div class="key">投资方</div>
                <div class="value">{{item2.investors}}</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="more"
        @click="more(2)">
        查看更多 >
      </div>
    </div>
    <div class="cutter"></div>

    <div class="exit fundding">
      <div class="title">
        <div>
          {{$t("existEvent")}}
        </div>
        <div class="txt">

          <span v-if="isIPO"
            style="color:#7D7D7D">{{$t("existEventIPO")}}</span>
          <span v-else
            style="color:#7D7D7D">{{$t("existEventTrade")}}</span>
        </div>
        <div class="switch">

          <van-switch v-model="isIPO"
            size="18px"
            active-color="#D04A02"
            inactive-color="#D04A02" />
        </div>
      </div>
      <div v-if="isIPO">
        <div class="item"
          v-for="item3 in data.exitIPOList"
          :key="item3.id">
          <div class="info">
            <div class="top">
              <div class="dot"></div>
              <div class="name"
                @click="gotoCompanyDetail(item3.company.id)">
                {{item3.company.name}}
              </div>
            </div>
            <div class="content">
              <div class="field">
                <span>行业：</span>
                <span>
                  <span v-for="fd in industryFieldArr(item3.company.industryField)"
                    :key="fd">
                    {{fd}}
                  </span>
                </span>
              </div>
              <div class="area">
                <span>上市地点：</span>
                <span>{{item3.stockExchangeName}}</span>
              </div>
              <div class="area">
                <span>上市时间：</span>
                <span> {{getDate(item3.listDate)}}</span>
              </div>
              <div class="area">
                <span>持有时长：</span>
                <span>{{calcDate(item3.holdingDays)}}</span>
              </div>
              <div class="invest">
                <div class="left">
                  <div class="key">首次投资时间</div>
                  <div class="value"
                    v-if="item3.firstFund">{{getDate(item3.firstFund.fundingDate)}}</div>
                </div>
                <div class="center">
                  <div class="key">首次投资轮次</div>
                  <div class="value"
                    v-if="item3.firstFund">{{item3.firstFund.round}}</div>
                </div>
                <div class="right">
                  <div class="key">投资次数</div>
                  <div class="value">{{item3.investCnt}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more"
          @click="more(3)">
          查看更多 >
        </div>
      </div>
      <div v-else>
        <div class="item"
          v-for="item4 in data.exitSalesList"
          :key="item4.id">
          <div class="info">
            <div class="top">
              <div class="dot"></div>
              <div class="name"
                @click="gotoCompanyDetail(item4.company.id)">
                {{item4.company.name}}
              </div>
            </div>
            <div class="content">
              <div class="desc">
                <span>公司简介：</span>
                <span> {{item4.company.introduction}}</span>
              </div>
              <div class="field">
                <span>行业：</span>
                <span>
                  <span v-for="fd in industryFieldArr(item4.company.industryField)"
                    :key="fd">
                    {{fd}}
                  </span>
                </span>
              </div>

              <div class="area">
                <span>被收购时间：</span>
                <span> {{getDate(item4.fundingDate)}}</span>
              </div>
              <div class="area">
                <span>被收购金额：</span>
                <span v-if="item4.investment">{{formatChineseAmount(item4.investment,item4.currency)}}</span>
                <div class="value"
                  v-else>{{formatDollar(item4.investmentDollar)}}</div>

              </div>
              <div class="area">
                <span>收购方：</span>
                <span>{{item4.investors}}</span>
              </div>
              <div class="invest">
                <div class="left">
                  <div class="key">持有时长</div>
                  <div class="value">{{calcDate(item4.holdingDays)}}</div>
                </div>
                <div class="center">
                  <div class="key">首次投资时间</div>
                  <div class="value"
                    v-if="item4.firstFund">{{getDate(item4.firstFund.fundingDate)}}</div>
                </div>
                <div class="right">
                  <div class="key">首次投资轮次</div>
                  <div class="value"
                    v-if="item4.firstFund">{{item4.firstFund.round}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more"
          @click="more(4)">
          查看更多 >
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import common from "@common/common";
import formatter from "@common/formatter";
export default {
  data () {
    return {
      isIPO: true,
    };
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  components: {},

  computed: {},

  mounted () { },

  methods: {
    formatChineseAmount (val, currency) {
      return formatter.formatChineseAmount(val, currency);
    },
    formatDollar (val) {
      return formatter.formatChineseAmount(val, "USD");
    },
    getSubContent (cont) {
      let contentsArr = JSON.parse(cont);
      for (let i = 0; i < contentsArr.length; i++) {
        let obj = contentsArr[i];
        if (common.isEmpty(obj.image) && !common.isEmpty(obj.content)) {
          return obj.content;
        }
      }
    },
    getDate (date) {
      if (!common.isEmpty(date)) {
        return this.$moment(date).format("yyyy/MM/DD");
      } else {
        return "";
      }
    },
    gotoCompanyDetail (id) {
      this.$router.push({
        path: "/investedDetail/" + Math.random() * 1000000,
        query: {
          id: id,
        },
      });
    },
    goDetail (id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: id,
          type: 0,
        },
      });
    },
    calcDate (days) {
      if (days <= 0) {
        return "";
      }
      if (days >= 365) {
        var years = (days * 1.0) / 365;
        return years.toFixed(2) + "年";
      } else {
        var mons = (days * 1.0) / 30;
        return mons.toFixed(2) + "个月";
      }
    },
    industryFieldArr (fields) {
      // debugger;
      if (fields) {
        return _.split(fields, ",", 4);
      } else {
        return [];
      }
    },
    more (type) {
      switch (type) {
        case 1:
          this.$router.push({
            path: "/listFundingNews/" + Math.random() * 1000000,
            query: {
              id: this.data.apiID,
            },
          });
          break;
        case 2:
          this.$router.push({
            path: "/listFunding",
            query: {
              id: this.data.apiID,
            },
          });
          break;
        case 3:
          this.$router.push({
            path: "/listExitIPO",
            query: {
              id: this.data.apiID,
            },
          });
          break;
        case 4:
          this.$router.push({
            path: "/listExitSales",
            query: {
              id: this.data.apiID,
            },
          });
          break;
      }
    },
  },
};
</script>
<style lang='less' scoped>
.inner-main {
  background-color: #fff;
}
.cutter {
  height: 8px;
  background-color: #f2f2f2;
}

.title-com {
  font-size: 16px;
  color: #2d2d2d;
  font-weight: 550;
}
.title {
  padding-left: 0.625rem;
  border-left: 2px solid #d04a02;
  margin-bottom: 30px;
  display: flex;
  .title-com();

  .txt {
    flex: 1;
    text-align: right;
    font-weight: 500;
    padding-right: 10px;
  }
  .switch {
    text-align: right;
  }
}
.fundding-news {
  padding: 1.125rem;
  .news-title {
    .title();
    margin-bottom: 18px;
  }
  .top {
    display: flex;
    .name {
      .title-com();
      font-size: 14px;
      margin-bottom: 12px;
      flex: 1;
    }
    .date {
      font-size: 12px;
      color: #7d7d7d;
      padding-top: 6px;
      width: 24%;
      text-align: right;
    }
  }
  .news-info {
    font-size: 14px;
    color: #7d7d7d;
    line-height: 22px;
    margin-bottom: 18px;

    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
.more {
  text-align: center;
  font-size: 14px;
  color: #c52a1a;
}
.fundding {
  padding: 1.125rem;

  .item:not(:nth-of-type(2)) {
    padding-top: 20px;
  }
  .item {
    border-left: 1px solid #dedede;
    .info {
      padding: 0.925rem 0.625rem 0.625rem 0.625rem;
      position: relative;
      .top {
        position: absolute;
        display: flex;
        top: -10px;
        left: -5px;
        width: 100%;
        .dot {
          background: #dedede;
          border-radius: 50%;
          height: 0.625rem;
          width: 0.625rem;
          // left: 0;
          // top: 7px;
          // transform: translateX(-50%);
        }
        .name {
          position: absolute;
          left: 16px;
          top: -7px;
          font-size: 16px;
          color: #464646;
          width: 100%;
        }
      }
      .content {
        .desc,
        .field,
        .area {
          line-height: 30px;
          font-size: 14px;
          color: #464646;
        }

        .invest,
        .invest2 {
          margin-top: 16px;
          margin-bottom: 16px;
          display: flex;
          .left,
          .center,
          .right {
            flex: 1;
          }
          .key {
            color: #7d7d7d;
            font-size: 12px;
            margin-bottom: 8px;
          }
          .value {
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }
  }
}

.exit {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/OrgEvents.vue